import React from "react"
export default function Title(props) {
    return <h1>{props.titleText}</h1>
}
